import React from 'react'

function BoyWriter() {
  return (
    <svg width={245} height={243} viewBox="0 0 245 243" fill="none">
      <mask
        id="prefix__a"
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={245}
        height={243}
      >
        <path
          d="M245 118c0 69.036-54.845 125-122.5 125S0 187.036 0 118 89.345 0 157 0s88 48.964 88 118z"
          fill="#F3F5F8"
        />
      </mask>
      <g mask="url(#prefix__a)">
        <path
          d="M245 118c0 69.036-54.845 125-122.5 125S0 187.036 0 118 89.345 0 157 0s88 48.964 88 118z"
          fill="#F3F5F8"
        />
        <path
          d="M130.532 174.156c4.099 11.458 5.797 63.844 5.797 72.749h-21.241l-8.832-19.888 15.353-55.686 8.923 2.825z"
          fill="#C01414"
        />
        <path
          d="M123.014 175.597c-1.155 7.662-11.482 65.201-13.791 71.281H78.538c-1.313-4.34-6.227-55.393 0-74.196 6.228-18.78 44.476 2.915 44.476 2.915z"
          fill="#D62929"
        />
        <path
          d="M128.335 145.181c1.948-.385 28.556-12.498 34.58-17.651 6.023-5.153-1.178-9.13-3.442-7.797-2.265 1.333-25.884 11.481-30.73 12.95-4.846 1.469-.408 12.498-.408 12.498z"
          fill="#B3B3B3"
        />
        <path
          d="M169.086 90.268l-19.349 1.506 2.914 37.291L172 127.559l-2.914-37.29z"
          fill="#E5E5E5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M141.203 98.403a.5.5 0 01.67.227l10.122 20.521a.5.5 0 11-.896.443l-10.123-20.521a.5.5 0 01.227-.67z"
          fill="#000"
        />
        <path
          d="M101.592 90.38c5.508-.601 9.264-7.556 8.39-15.534-.874-7.979-6.048-13.96-11.556-13.358-5.507.6-9.264 7.556-8.39 15.534.874 7.978 6.048 13.959 11.556 13.358z"
          fill="#B3B3B3"
        />
        <path
          d="M98.013 92.657c33.516 0 35.078 81.473 33.606 82.942-1.472 1.469-35.553 8.362-54.122.678-4.53-19.662-1.45-83.62 20.516-83.62z"
          fill="#4D4D4D"
        />
        <path
          d="M151.049 109.588c0-1.899-2.038-5.876-5.028-5.176-2.06.475-4.891 4.611-6.114 6.351-4.144 2.848-30.39 24.498-32.405 26.6-.091-1.74-1.767-5.243-3.782-8.498l-17.097 11.029c1.766 4.904 12.794 17.854 17.097 17.854 11.277 0 34.059-30.555 39.833-38.759 2.695-1.875 7.496-5.604 7.496-9.401z"
          fill="#B3B3B3"
        />
        <path
          d="M82.795 68.86c0-4.248 3.442-6.734 4.575-7.886 2.264-2.35 3.623-8.611 8.401-8.611 1.359 0 3.465.79 4.801.79 1.653 0 4.959-3.276 8.288-3.276 5.571 0 6.817 5.13 6.817 6.69 0 5.763-7.202 10.124-8.153 10.644-.407-.655-2.264-3.141-2.876-3.503-.747 1.537-5.73 4.113-9.51 6.396-2.107 1.288-3.443 11.277-3.42 12.068-3.533.023-8.923-5.31-8.923-13.311z"
          fill="#0D0D0D"
        />
        <path
          d="M91.151 81.226a2.828 2.828 0 002.831-2.825 2.828 2.828 0 00-2.83-2.825A2.828 2.828 0 0088.32 78.4a2.828 2.828 0 002.83 2.825zM102.768 98.06c.227 1.424-8.673 1.063-8.786-.452l-.974-14.192 8.062-.882s1.495 14.125 1.698 15.526z"
          fill="#B3B3B3"
        />
        <path
          d="M80.282 104.864c-10.01 5.446-1.064 33.696 5.254 36.589 7.133 0 21.558-10.306 21.558-13.809s-13.836-29.832-26.812-22.78z"
          fill="#4D4D4D"
        />
        <path
          d="M163.889 106.963c0 4.7 5.593 7.164 6.408 7.164 1.699 0 1.699-5.131 1.699-6.464 0-3.028-2.967-5.243-5.209-5.243-2.242 0-2.898 1.876-2.898 4.543z"
          fill="#B3B3B3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M104.707 75.595a.5.5 0 01.698.112c.055.077.123.161.207.266l.004.006c.083.103.178.222.27.348.183.25.381.56.49.916.112.368.13.786-.05 1.22-.177.422-.521.812-1.039 1.175a.5.5 0 11-.574-.819c.42-.294.609-.548.689-.741a.76.76 0 00.018-.541c-.061-.198-.182-.403-.341-.62a8.333 8.333 0 00-.256-.33 8.09 8.09 0 01-.228-.294.5.5 0 01.112-.698zM102.496 81.848c-.715.006-1.35.35-1.527.825a.5.5 0 01-.937-.348c.383-1.032 1.539-1.47 2.456-1.477.475-.004.972.103 1.361.368.411.28.682.73.651 1.312a.5.5 0 01-.999-.054.449.449 0 00-.215-.432c-.172-.117-.45-.196-.79-.194z"
          fill="#1F161E"
        />
        <ellipse
          cx={98.5}
          cy={76}
          rx={0.5}
          ry={1}
          transform="rotate(86.39 98.5 76)"
          fill="#0D0D0D"
        />
        <ellipse
          cx={108.501}
          cy={76.001}
          rx={0.5}
          ry={1}
          transform="rotate(-87.302 108.501 76)"
          fill="#0D0D0D"
        />
        <path
          d="M97 80c1.105 0 2-.448 2-1s-.895-1-2-1-2 .448-2 1 .895 1 2 1z"
          fill="#FA9E9F"
        />
      </g>
    </svg>
  )
}

export default React.memo(BoyWriter)
